import React, { useEffect } from "react";
import logoImg from './images/logobithappier.png';
import homeLogoFund from './images/mainLogo.webp';
import HomepageHeader from './HomepageHeader';
import './Homepage.css';
import aboutImg from './images/aboutimg.svg';
import ourVision from './images/vision.svg';
import ourMission from './images/mission.svg';
import ourVisionMission from './images/visionmission.svg';
import Team from './Landingpage/Components/Team';
import Roadmap from './Landingpage/Components/Roadmap';
import FooterHome from './FooterHome';
import FooterHomeStripe from './FooterHomeStripe';
import Cookies from 'universal-cookie';
import DashboardHeader from './DashboardHeader';
import ProfessionalHeader from '../Professionals/ProfessionalHeader';
import { DecodingString } from '../helperFunction/DecodingString';
import { useNavigate } from 'react-router-dom';
import back from './images/ArrowRight.png'
import final from './images/finalHome.png'
import './Tickets.css'

const Ticket = () => {
  const cookies = new Cookies();
  const token = cookies.get('isLoggedIn', { path: '/' });
  const roleType = DecodingString(cookies.get('_ssUuId', { path: '/' }));
  const navigate = useNavigate();

  const sponsorLinks = {
    diamond: "https://www.zeffy.com/en-CA/ticketing/2026-illuminate-champions-for-change-fundraiser",
    platinum: "https://www.zeffy.com/en-CA/ticketing/2026-illuminate-champions-for-change-fundraiser",
    gold: "https://www.zeffy.com/en-CA/ticketing/2026-illuminate-champions-for-change-fundraiser",
    silver: "https://www.zeffy.com/en-CA/ticketing/2026-illuminate-champions-for-change-fundraiser",
    bronze: "https://www.zeffy.com/en-CA/ticketing/2026-illuminate-champions-for-change-fundraiser",
    individual: "https://www.zeffy.com/en-CA/ticketing/2026-illuminate-champions-for-change-fundraiser",
  };

  const handleCardClick = (url, e) => {
    // Prevent double-navigation if button was clicked
    if (e.target.tagName === 'A' || e.target.closest('a')) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@700&family=Barlow+Condensed:wght@400;700;800&family=Barlow:wght@400&display=swap"
        rel="stylesheet"
      />

      <header>
        {token ? (
          <>
            {roleType === 'ROLE_USER' || roleType === 'ROLE_CORPORATE' ? (
              <DashboardHeader />
            ) : (
              <ProfessionalHeader />
            )}
          </>
        ) : (
          <HomepageHeader />
        )}
      </header>
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@700&family=Barlow+Condensed:wght@400;700;800&family=Barlow:wght@400&display=swap"
        rel="stylesheet"
      />


      {/* ── HERO SECTION ── */}
      <div className="fundraiser-hero hero-shadow-fix">
        <div className="fundraiser-top-bar">
          <div className="fundraiser-logo">
            <span
              onClick={() => navigate(-1)}
              className="fundraiser-back-link"
            >
              <img className="me-2" src={back} alt="" width={20} />
              Back
            </span>
          </div>
          <a
            href="https://stigmafreementalhealth.com/donate/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-tickets fundraiser-donate-btn"
            aria-label="Donate today"
          >
            Donate Today
          </a>
        </div>
        <div className="fundraiser-bottom-container">
          <p className="fundraiser-bottom-text">2026 FUNDRAISER</p>
        </div>
      </div>

      {/* ── CARD SECTION ── */}
      <div className="main-wrapper">
        <div className="card-wrapper">
          <div className="card">
            <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/sparkles.png" alt="" className="sparkles" />
            <div className="top-content">
              <p className="label">Fundraiser</p>
              <h1 className="title">
                Illuminate:<br />
                Champions for Change
              </h1>
            </div>
            <p className="support-text">
              This event provides a remarkable opportunity to showcase the transformative efforts of 5 exceptional organizations that are changing lives. We are raising funds together to address the critical issue of loneliness and mental health struggles.<br />
            </p>
            <p className="support-text">You will receive a charity tax receipt for 50% of the amount paid for sponsorships and tickets.</p>
            <div style={{ padding: '60px 0px' }}>
              <div className="about-ribbon-ticket">
                <span className="about-ribbon-ticket-text">
                  Strategic Sponsorship Opportunities
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── SPONSORSHIP LEVELS & BENEFITS SECTION ── */}
      <section className="sponsorship-section">
        <img
          src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/sparkles.png"
          alt=""
          className="sponsorship-bg-top"
        />
        <img
          src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/dec-corner-legft-296x300.png"
          alt=""
          className="sponsorship-floral-corner"
        />
        <div className="sponsorship-inner">
          <h2 className="sponsorship-title">Sponsorship Levels &amp; Benefits</h2>

          <div className="tiers-grid">

            {/* DIAMOND */}
            <div className="tier-card">
              <div className="tier-header tier-header-bg diamond">
                <p className="tier-name diamond">Diamond 💎</p>
                <p className="tier-avail">Premier Sponsorship | 3 Opportunities Available | Includes Ten Tickets</p>
              </div>
              <div className="tier-price"><span>$</span>25,000+</div>
              <ul className="tier-benefits">
                <li>Premier brand recognition across event materials, website, and on-site signage</li>
                <li>Featured promotion through six social media posts across our 50,000+ network and inclusion in the post-event highlight video</li>
                <li>Confirmed media coverage with Business in Vancouver (BIV) plus additional media opportunities</li>
                <li>Premium logo placement across event marketing and communications</li>
                <li>Deliver a 3-minute welcome address during the program to 150 attendees</li>
              </ul>
              <div className="tier-btn-wrap">
                <a
                  href={sponsorLinks.diamond}
                  className="tier-btn diamond"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Become a Diamond Sponsor
                </a>
              </div>
            </div>

            {/* PLATINUM */}
            <div className="tier-card">
              <div className="tier-header tier-header-bg platinum">
                <p className="tier-name platinum">Platinum</p>
                <p className="tier-avail">5 Opportunities Available | Includes Eight Tickets</p>
              </div>
              <div className="tier-price"><span>$</span>20,000</div>
              <ul className="tier-benefits">
                <li>Prominent brand recognition across event materials, website, and on-site signage</li>
                <li>Featured promotion through four social media posts across our 50,000+ network and inclusion in the post-event highlight video</li>
                <li>On-site recognition and verbal acknowledgement during the event</li>
                <li>Confirmed media coverage with Business in Vancouver (BIV) plus additional media opportunities</li>
                <li>Logo featured in the post-event highlight video</li>
              </ul>
              <div className="tier-btn-wrap">
                <a
                  href={sponsorLinks.platinum}
                  className="tier-btn platinum"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Become a Platinum Sponsor
                </a>
              </div>
            </div>

            {/* GOLD */}
            <div className="tier-card gold-featured" style={{ position: 'relative' }}>
              <span className="featured-badge">Popular</span>
              <div className="tier-header tier-header-bg gold">
                <p className="tier-name gold">Gold</p>
                <p className="tier-avail">8 Opportunities Available | Includes Six Tickets</p>
              </div>
              <div className="tier-price"><span>$</span>10,000</div>
              <ul className="tier-benefits">
                <li>Featured promotion through three social media posts on 50,000+ network and inclusion in the post-event highlight video</li>
                <li>On-site logo recognition and verbal recognition at the event</li>
                <li>Confirmed media coverage with Business in Vancouver (BIV) plus additional media opportunities</li>
                <li>Logo featured in post-event highlight video</li>
              </ul>
              <div className="tier-btn-wrap">
                <a
                  href={sponsorLinks.gold}
                  className="tier-btn gold"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Become a Gold Sponsor
                </a>
              </div>
            </div>

            {/* SILVER */}
            <div className="tier-card">
              <div className="tier-header tier-header-bg silver">
                <p className="tier-name silver">Silver</p>
                <p className="tier-avail">9 Opportunities Available | Includes Four Tickets</p>
              </div>
              <div className="tier-price"><span>$</span>5,000</div>
              <ul className="tier-benefits">
                <li>Featured promotion through two social media posts on 50,000+ network</li>
                <li>Logo featured on the event website</li>
                <li>On-site logo recognition at the event</li>
                <li>Logo featured in the post-event highlight video</li>
              </ul>
              <div className="tier-btn-wrap">
                <a
                  href={sponsorLinks.silver}
                  className="tier-btn silver"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Become a Silver Sponsor
                </a>
              </div>
            </div>

            {/* BRONZE */}
            <div className="tier-card">
              <div className="tier-header tier-header-bg bronze">
                <p className="tier-name bronze">Bronze</p>
                <p className="tier-avail">18 Opportunities Available | Includes Two Tickets</p>
              </div>
              <div className="tier-price"><span>$</span>2,500</div>
              <ul className="tier-benefits">
                <li>Logo featured on event website</li>
                <li>On-site logo recognition at the event</li>
                <li>Featured promotion through one social media post on our 50,000+ platform</li>
              </ul>
              <div className="tier-btn-wrap">
                <a
                  href={sponsorLinks.bronze}
                  className="tier-btn bronze"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Become a Bronze Sponsor
                </a>
              </div>
            </div>

          </div>

          {/* INDIVIDUAL SUPPORTER - FULL CARD CLICKABLE */}
          <div className="individual-wrap">
            <div
              className="individual-card"
              onClick={(e) => handleCardClick(sponsorLinks.individual, e)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  window.open(sponsorLinks.individual, '_blank', 'noopener,noreferrer');
                }
              }}
              aria-label="Purchase Individual Supporter Ticket - $199"
            >
              <div className="individual-inner">
                <h3 className="individual-title">Individual Supporter</h3>
                <p className="individual-price">$199</p>
                <a
                  href={sponsorLinks.individual}
                  className="individual-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  Purchase Ticket
                </a>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* ── THANK YOU FOR YOUR SUPPORT SECTION ── */}
      <section className="support-section">
        <div className="support-inner">
          <h2 className="support-title">Thank You For Your Support.</h2>
          <p className="support-text">
            Together, we inspire diverse communities to be inclusive, compassionate,<br />
            and empowered to lead fulfilling lives regardless of their challenges.
          </p>
        </div>
      </section>

      <footer

      >
        <FooterHome />
        <FooterHomeStripe />
      </footer>
    </>
  );
};
export default Ticket;